import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { Root, classes } from './utils';
import {
  connectSocket,
  // disconnectSocket,
} from '../../../../store/socketConfigSlice';
import { completeNotification } from '../../../../store/socketSlice';
import Toast from '../../utils/Toast';
import {
  getGridFilterSortStatus,
  getRowData,
  pendingInprogress,
} from '../../../../services/allInvoiceApi';
import 'pdfjs-dist/build/pdf.worker.min.mjs';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import documentColumnDef from '../documents/documentColumnDef';
import MODELS from '../../../../constants/models';
import {
  tokenExchange,
  tokenExchangeForXero,
} from '../../../../services/flowConfiguration';
import {
  THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_INVOICES,
  THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SALES,
  THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_RECEIPT,
} from '../../../../constants/Constants';
import {
  createManualAuthCredential,
  quickBookExportManually,
  tokenExchangeForQB,
  xeroExport,
  zohoExport,
} from '../../../../services/exportApi';
import TaxMapping from '../flow-configuration/TaxMapping';

const TabsSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const notifyUser = useSelector((states) => states.socket.notification);
  const isConnected = useSelector((states) => states.socketConfig.isConnected);
  const userDetail = useSelector((states) => states.user.user);
  const userId = userDetail?.id;
  const notificationMessage = notifyUser?.message;
  const DocumentCompletedId = notifyUser?.invoice_id;
  const DocumentCompletedData = notifyUser?.status;
  const DocumentFailedReason = notifyUser?.errorMessage;
  const [gridSettingData, setGridSettingData] = useState({});
  const [isStageLoaded, setIsStageLoaded] = useState(true);
  const [uploadPending, setUploadPending] = useState(false);
  const [invoices, setInvoices] = useState(0);
  const [isExportedInQB, setIsExportedInQB] = useState(false);
  const [documentType, setDocumentType] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const realmId = urlParams.get('realmId');
  const exportOptionFromSessionStorage = sessionStorage.getItem('exportOption');
  const displayNameFromSessionStorage = sessionStorage.getItem(
    'displayNameForCredential',
  );
  const invoiceIds = sessionStorage.getItem('invoiceId');
  const [openTaxPopup, setOpenTaxPopup] = useState(false);
  const [credentialId, setCredentialId] = useState();
  const [exportType, setExportType] = useState();
  const [credentialData, setCredentialData] = useState();
  const isManual = true;
  const handleZohoAndQuickBooksCallback = async () => {
    let baseUrl = '';
    let documentTypeForPayload = '';

    if (location.pathname.includes('sales')) {
      baseUrl = THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SALES;
      documentTypeForPayload = MODELS.SALES;
    } else if (location.pathname.includes('invoices')) {
      baseUrl = THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_INVOICES;
      documentTypeForPayload = MODELS.INVOICE;
    } else if (location.pathname.includes('receipts')) {
      baseUrl = THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_RECEIPT;
      documentTypeForPayload = MODELS.RECEIPT;
    }

    const handleRedirect = (url) => {
      window.location.href = url;
    };

    const handleTokenExchange = async (tokenData, label) => {
      let newCredential;
      if (tokenData?.email) {
        if (label === 'Zoho') {
          const {
            email,
            refresh_token: refreshToken,
            scope,
            api_domain: apiDomain,
          } = tokenData;
          newCredential = {
            label,
            credential: {
              email,
              refresh_token: refreshToken,
              scope,
              apiDomain,
            },
          };
        } else {
          newCredential = {
            label,
            credential: tokenData,
          };
        }
        setCredentialData(newCredential);
        const credential = await createManualAuthCredential(
          newCredential,
          false,
          displayNameFromSessionStorage,
        );
        sessionStorage.removeItem('displayNameForCredential');
        if (credential) {
          sessionStorage.setItem('invoiceId', params?.id);
          navigate(
            documentTypeForPayload === MODELS.INVOICE
              ? '/invoices'
              : documentTypeForPayload === MODELS.SALES
                ? '/sales'
                : '/receipts',
          );
          setExportType(label);
          setCredentialId(credential?.id);
          setOpenTaxPopup(true);
        }
      } else {
        Toast({ message: `${tokenData?.message}`, variant: 'error' });
      }
    };

    if (code) {
      if (!realmId) {
        if (state) {
          handleRedirect(`${baseUrl}/${state}?code=${code}`);
        } else if (exportOptionFromSessionStorage === 'Xero') {
          const tokenData = await tokenExchangeForXero(
            code,
            'Manual',
            documentTypeForPayload,
          );
          if (tokenData) {
            sessionStorage.removeItem('exportOption');
            await handleTokenExchange(tokenData, 'Xero', xeroExport);
          }
        } else if (exportOptionFromSessionStorage === 'Zoho') {
          const tokenData = await tokenExchange(
            code,
            'Manual',
            documentTypeForPayload,
          );
          if (tokenData) {
            sessionStorage.removeItem('exportOption');
            await handleTokenExchange(tokenData, 'Zoho', zohoExport);
          }
        }
      } else if (state) {
        handleRedirect(`${baseUrl}/${state}?code=${code}&realmId=${realmId}`);
      } else {
        setIsExportedInQB(true);
        const tokenData = await tokenExchangeForQB(
          code,
          realmId,
          documentTypeForPayload,
        );
        await handleTokenExchange(
          tokenData,
          'QuickBook',
          quickBookExportManually,
        );
        setIsExportedInQB(false);
      }
    }
  };

  useEffect(() => {
    handleZohoAndQuickBooksCallback();
  }, [code]);

  useEffect(() => {
    if (notificationMessage && DocumentCompletedData === 'Completed') {
      Toast({ message: `${notificationMessage}`, variant: 'success' });

      dispatch(completeNotification({}));
    }
  }, [notificationMessage]);

  const fetchInvoices = async (type) => {
    try {
      return await pendingInprogress(type);
    } catch {
      return [];
    }
  };

  const loadInvoices = async (type) => {
    const fetchedInvoices = await fetchInvoices(type);
    setInvoices(fetchedInvoices);
  };

  useEffect(() => {
    if (Object.keys(notifyUser)?.length > 0) {
      loadInvoices(documentType);
    }
  }, [notifyUser, documentType]);

  useEffect(() => {
    if (invoices > 0 && userId && !isConnected) {
      dispatch(connectSocket(userId));
    } else if (invoices === 0 && isConnected) {
      // dispatch(disconnectSocket());
    }
  }, [dispatch, invoices, userId, isConnected]);

  useEffect(
    () => () => {
      if (isConnected) {
        // dispatch(disconnectSocket());
      }
    },
    [dispatch, location, isConnected],
  );

  const getFilterSortData = async () => {
    let key;
    if (location.pathname.includes('sales')) {
      key = 'sales';
    } else if (location.pathname.includes('invoices')) {
      key = 'invoices';
    } else if (location.pathname.includes('bank-statements')) {
      key = 'bank-statements';
    } else if (location.pathname.includes('creditcardstatements')) {
      key = 'creditcardstatements';
    } else {
      key = 'receipts';
    }

    try {
      const response = await getGridFilterSortStatus(key);
      setGridSettingData(response);
      if (
        !response?.filter ||
        (response?.filter &&
          Object.keys(response.filter).length > 0 &&
          (response?.filter?.tag?.length > 0 ||
            response?.filter?.stage !== '' ||
            response !== null)) ||
        response === null
      ) {
        setIsStageLoaded(false);
      }
    } catch (err) {
      setIsStageLoaded(false);
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
    if (location.pathname.includes('invoices')) {
      setDocumentType(MODELS.INVOICE);
      loadInvoices(MODELS.INVOICE);
    } else if (location.pathname.includes('receipts')) {
      setDocumentType(MODELS.RECEIPT);
      loadInvoices(MODELS.RECEIPT);
    } else if (location.pathname.includes('sales')) {
      setDocumentType(MODELS.SALES);
      loadInvoices(MODELS.SALES);
    } else if (location.pathname.includes('bank-statements')) {
      setDocumentType(MODELS.BANK_STATEMENT);
      loadInvoices(MODELS.BANK_STATEMENT);
    } else if (location.pathname.includes('creditcardstatements')) {
      setDocumentType(MODELS.CREDIT_CARD_STATEMENT);
      loadInvoices(MODELS.CREDIT_CARD_STATEMENT);
    }
  }, []);

  const getTitleHeader = () => {
    if (location.pathname.includes('sales')) {
      return 'Sales Invoices';
    }
    if (location.pathname.includes('invoices')) {
      return 'Direct Expenses';
    }
    if (location.pathname.includes('bank-statements')) {
      return 'Bank Statements';
    }
    if (location.pathname.includes('creditcardstatements')) {
      return 'Credit Card Statements';
    }
    return 'Indirect Expenses';
  };

  const getGridKey = () => {
    if (location.pathname.includes('sales')) {
      return 'invoices';
    }
    if (location.pathname.includes('invoices')) {
      return 'invoices';
    }
    if (location.pathname.includes('bank-statements')) {
      return 'bank-statements';
    }
    if (location.pathname.includes('creditcardstatements')) {
      return 'creditcardstatements';
    }
    return 'receipts';
  };
  const getDocumentExportFunc = (type) => {
    switch (type) {
      case 'Zoho':
        return zohoExport;
      case 'QuickBook':
        return quickBookExportManually;
      default:
        return xeroExport;
    }
  };
  const closePopup = () => {
    setOpenTaxPopup(false);
  };
  return (
    <Root className={classes.root}>
      {uploadPending || isExportedInQB ? (
        <Backdrop
          className={classes.uploadLoader}
          open={uploadPending || isExportedInQB}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}

      {isStageLoaded ? (
        <Box className={classes.loaderBox}>
          <CircularProgress />
        </Box>
      ) : (
        <AgGrid
          className={classes.invoicesAgGridStyle}
          TitleHeader={getTitleHeader()}
          columnData={documentColumnDef}
          getRowData={getRowData}
          DocumentCompletedId={DocumentCompletedId}
          DocumentCompletedData={DocumentCompletedData}
          DocumentFailedReason={DocumentFailedReason}
          gridSettingData={gridSettingData}
          functionData={documentType}
          gridKey={getGridKey()}
          setUploadPending={setUploadPending}
          setGridSettingData={setGridSettingData}
        />
      )}
      {openTaxPopup && (
        <TaxMapping
          exportType={exportType}
          credentialId={credentialId}
          invoiceIds={[invoiceIds]}
          handleNewAndExport={() => {}}
          newCredential={credentialData}
          isManual={isManual}
          documentExportFunc={getDocumentExportFunc(exportType)}
          openTaxPopup={openTaxPopup}
          closePopup={closePopup}
        />
      )}
    </Root>
  );
};

export default TabsSection;
